import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconNoDataStyle0 = cosmosIconCss;

const CosmosIconNoData$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconNoData extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b618bb77aceecf1c127c154b3f260980d4ff446a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '28b60e0734b8271129596e4e016e030349b950b4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '55d164c21e1e6e4ddc674384cd84cbf2fae62762', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6.253 5.193A7.469 7.469 0 0 1 11 3.5a7.51 7.51 0 0 1 7.5 7.5 7.47 7.47 0 0 1-1.693 4.747L6.253 5.193Zm-1.06 1.06a7.5 7.5 0 0 0 10.554 10.554L5.192 6.253ZM2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconNoDataStyle0; }
}, [1, "cosmos-icon-no-data", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-no-data"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-no-data":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconNoData$1);
            }
            break;
    } });
}

const CosmosIconNoData = CosmosIconNoData$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconNoData, defineCustomElement };
